
// src/components/Dashboard.js
import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import useContentful from '../../Hooks/Contentful';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const { getOrders } = useContentful(); // Fetching orders for calculations

  useEffect(() => {
    // Fetch orders from the API
    getOrders().then((orders) => {
      console.log("YOU",orders)
      if (orders) {
        const totalOrders = orders.length;
        const completedOrders = orders.filter(order => order?.paymentstatus?.toLowerCase() == "successful").length;
        const incompletedOrders = orders.filter(order => order?.paymentstatus?.toLowerCase() == "pay-offline").length;
        const Failed = orders.filter(order => order?.paymentstatus?.toLowerCase() == "failed").length;
        const pendingOrders = totalOrders - completedOrders;
        
        // Calculate revenue as a number
        const revenue = orders.reduce((acc, order) => acc + (parseFloat(order.totalpay) || 0), 0);
        
        // Calculate average order value
        const averageOrderValue = totalOrders ? (revenue / totalOrders) : 0;

        // Set calculated data
        setDashboardData({
          totalOrders,
          completedOrders,
          pendingOrders,
          revenue,
          averageOrderValue,
          Failed,
          incompletedOrders
        });
      }
    });
  //}, [getOrders]);
  }, []);

  // Fallback if API data is not available yet
  const data = dashboardData || {
    totalOrders: 0,
    completedOrders: 0,
    pendingOrders: 0,
    revenue: 0,
    averageOrderValue: 0,
    incompletedOrders: 0,
    Failed: 0,

  };

  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      <div className="data-points">
        <div className="data-point">
          <h3>Total Orders</h3>
          <p>{data.totalOrders}</p>
        </div>
        <div className="data-point">
          <h3>Completed Orders</h3>
          <p>{data.completedOrders}</p>
        </div>
        <div className="data-point">
          <h3>Incomplete Payments</h3>
          <p>{data.completedOrders}</p>
        </div>
        <div className="data-point">
          <h3>Payment failed</h3>
          <p>{data.completedOrders}</p>
        </div>
        <div className="data-point">
          <h3>Pending Orders</h3>
          <p>{data.pendingOrders}</p>
        </div>
        <div className="data-point">
          <h3>Total Revenue</h3>
          <p>ZMK{data.revenue.toFixed(2)}</p>
        </div>
        <div className="data-point">
          <h3>Average Order Value</h3>
          <p>ZMK{data.averageOrderValue.toFixed(2)}</p>
        </div>
      </div>
      <div className="chart-container">
        <h3>Order Status Breakdown</h3>
        {/* Placeholder for future chart implementation */}
        <div className="chart-placeholder">Chart Placeholder</div>
      </div>
    </div>
  );
};

export default Dashboard;

// // src/components/Dashboard.js
// import React from 'react';
// import './Dashboard.css';

// const Dashboard = () => {
//   const dummyData = {
//     totalOrders: 150,
//     completedOrders: 120,
//     pendingOrders: 30,
//     revenue: 5000,
//     averageOrderValue: 33.33,
//   };

//   return (
//     <div className="dashboard">
//       <h2>Dashboard</h2>
//       <div className="data-points">
//         <div className="data-point">
//           <h3>Total Orders</h3>
//           <p>{dummyData.totalOrders}</p>
//         </div>
//         <div className="data-point">
//           <h3>Completed Orders</h3>
//           <p>{dummyData.completedOrders}</p>
//         </div>
//         <div className="data-point">
//           <h3>Pending Orders</h3>
//           <p>{dummyData.pendingOrders}</p>
//         </div>
//         <div className="data-point">
//           <h3>Total Revenue</h3>
//           <p>${dummyData.revenue.toFixed(2)}</p>
//         </div>
//         <div className="data-point">
//           <h3>Average Order Value</h3>
//           <p>${dummyData.averageOrderValue.toFixed(2)}</p>
//         </div>
//       </div>
//       <div className="chart-container">
//         <h3>Order Status Breakdown</h3>
//         {/* Placeholder for future chart implementation */}
//         <div className="chart-placeholder">Chart Placeholder</div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;
